// -*- Mode: rjsx -*-
import React, { useState}  from 'react';
import axios from 'axios';

import Morty from '../data/Morty';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import EmailIcon from '@mui/icons-material/MailOutline';
import SendIcon from '@mui/icons-material/Send';
import SyncIcon from '@mui/icons-material/Sync';

// import Avatar from '@mui/material/Avatar';
import Box  from '@mui/material/Box';
import Grid  from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import Slide from '@mui/material/Slide';


import { FHMaterialStyles, FHSideContainer } from "../ui/fh-material-styles.js";
import EmailSent from '../ui/EmailSent';

function SendButton(props) {
    const classes = FHMaterialStyles();

    
    if (props.sending || props.creating) {
        return (<Button
                  className={classes.button}
                  type="submit"
                  fullWidth
                  name="submit"
                  variant="contained"
                  endIcon={<SyncIcon />}                  
                  disabled
                >
                { props.sending ? "Sending Password Email" : "Creating User" }
                </Button>);
    }
    return (
        <Button
          className={classes.button}
          type="submit"
          fullWidth
          name="submit"
          variant="contained"
          endIcon={<SendIcon />}
        >
          Send Signup Link
        </Button>
    );
}


function AssistantSignup() {

    const [errors, setErrors] = useState([]);
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [sending, setSending] = useState(false);
    const [creating, setCreating] = useState(false);            


    const initiateReset = (userEmail) => {
        setSending(true);
	    Morty
            .post('/morty/auth/password/start-reset/', { email: userEmail, send_to: '/job/survey' })
            .then((data) => {
                setSent(true);
                setSending(false);                
            }).
            catch((data) => {
                setErrors(["Oops", "There was an error sending password reset email."]);
            });
    };
    
    const handleSubmit = (event) => {
        event.preventDefault();
        setCreating(true);
	    Morty
            .post('/morty/auth/assistant/create/', { email: email })
            .then((data) => {
                setCreating(false);
                initiateReset(email);
            }).
            catch((data) => {
                setErrors(["Oops", "There was an error creating your account."]);
            });
    };

    const handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if(name == 'email')
            setEmail(value);
        else if(name == 'password')
            setPassword(value);
    };

    const classes = FHMaterialStyles();
    let errorDisplay = null;
    
    if(errors.length) {
        errorDisplay = (
            <div >
              <h2 style={classes.errors.h2}>{ errors[0] }</h2>
              <h3 style={classes.errors.h3}>{ errors[1] }</h3>
            </div>
        );
    }

	return (
        
        <FHSideContainer>
          { sent &&  <EmailSent /> }
          
          { !sent &&
		    <form onSubmit={handleSubmit} noValidate>

            {errorDisplay}

            <Typography component="h2" variant="h5" align="center">
              Setup your account
            </Typography>
            
            <Grid container>
              <Grid item xs>
                <Typography align="center">
                  Let&apos;s confirm your email address.
                </Typography>
              </Grid>
            </Grid>            
            
            <TextField
              onChange={handleChange}
              value={email}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />

              <SendButton sending={sending} creating={creating} />

          </form>
          }

          
          <div style={{ marginTop: 50,
                        borderTop: "1px solid #D0D0D0",
                        paddingTop: 50
                      }}>

            <Typography variant="h6" align="center" color="textSecondary">
              Why do we send this email?
            </Typography>
            
            <Typography variant="body2" align="center" color="textSecondary">
              We need to verify that we can contact you via email.
            </Typography>
          </div>
          
        </FHSideContainer>
	);

    
}




export default AssistantSignup;
